import ContinerPrice from "./ContinerPrice";


export default ({data, click_select_flight}) => {

    let data_back_and_forth = {};

    data.map((value) => {
        let name_spilt = value['flight'][2].split('-');

        if (name_spilt.length === 3) {
            let n = name_spilt[2];

            (! data_back_and_forth[name_spilt[1]]) && (data_back_and_forth[name_spilt[1]] = {});

            data_back_and_forth[name_spilt[1]][n] = value;
        }
    })

    return (<>

    {
        Object.values(data_back_and_forth).map((dataTwo, key) => {
            if (Object.keys(dataTwo).length === 2) {
                let tr_to_return = [];

                const [away, back] = [dataTwo['A'], dataTwo['R']];

                console.log(away, back);

                const [tdAway, tdBack] = [[], []];

                for (let i = 2; i < away['flight'].length - 1; i ++) {
                    if (away['flight'][i] === back['flight'][i]) {
                        tdAway.push(<td rowSpan={2} key={i}> {away['flight'][i]} </td>);
                    } else {
                        tdAway.push(<td key={i}> {away['flight'][i]} </td>);
                        tdBack.push(<td key={i}> {back['flight'][i]} </td>);
                    }
                }

                tdAway.push(
                <td rowSpan={2} key={Object.keys(dataTwo).length}>
                    <ContinerPrice price={away['price']} r_price={away['r_price']} places={away['places']} />
                </td>
                )

                tr_to_return.push(<tr key={(key * 2) + 1} className="backAndForth" 
                onDoubleClick={() => click_select_flight({A: [away['key'], ...away['flight'].slice(2, -1)], R: [back['key'], ...back['flight'].slice(2, -1)]})}> 
                    {tdAway} 
                </tr>
                );
                tr_to_return.push(<tr key={(key * 2) + 2} className="backAndForth" 
                onDoubleClick={() => click_select_flight({A: [away['key'], ...away['flight'].slice(2, -1)], R: [back['key'], ...back['flight'].slice(2, -1)]})}> 
                    {tdBack} 
                </tr>
                );

                return tr_to_return;
            }
        })
    }
    </>)
}







